import { render, staticRenderFns } from "./TreemapAreaFailedDelivery.vue?vue&type=template&id=52aec0fe&lang=pug&"
import script from "./TreemapAreaFailedDelivery.vue?vue&type=script&lang=ts&"
export * from "./TreemapAreaFailedDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./TreemapAreaFailedDelivery.vue?vue&type=style&index=0&id=52aec0fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports